import { useEffect, useState } from "react";
import api from "@/lib/api";

const FALLBACK = [
  { date_label: "APR 2026", title: "DOJ settles disability discrimination case — Indian Oaks Apartments / Russell Management", amount: "$750,000", source_url: "https://www.justice.gov/opa/pr/justice-department-settles-disability-discrimination-case-against-property-management" },
  { date_label: "APR 2026", title: "Kentucky landlord barred from rental industry in harassment case", amount: "$510,000", source_url: "https://www.justice.gov/crt/recent-accomplishments-housing-and-civil-enforcement-section" },
  { date_label: "JUL 2026", title: "East Hampton Housing Authority assistance-animal settlement", amount: "$82,500", source_url: "https://www.justice.gov/crt/recent-accomplishments-housing-and-civil-enforcement-section" },
  { date_label: "MAR 2026", title: "Green Bay landlord settlement requires fair-housing training, 2-year monitoring", amount: "$50,000", source_url: "https://www.justice.gov/opa/pr/justice-department-secures-settlement-sexual-harassment-lawsuit-against-green-bay-landlord" },
  { date_label: "JAN 2026", title: "Decoy RV Park disability discrimination and retaliation settlement", amount: "$20,000", source_url: "https://www.justice.gov/crt/recent-accomplishments-housing-and-civil-enforcement-section" },
];

export const CaseTicker = () => {
  const [items, setItems] = useState(FALLBACK);

  useEffect(() => {
    api.get("/enforcement-cases")
      .then((res) => { if (Array.isArray(res.data) && res.data.length) setItems(res.data); })
      .catch(() => {});
  }, []);

  return (
    <div className="bg-white border-b border-slate-200 py-3.5 overflow-hidden" data-testid="case-ticker" aria-label="Latest fair-housing enforcement actions">
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            <span className="px-6 text-[11px] font-mono font-semibold uppercase tracking-[0.22em] text-sky-600 whitespace-nowrap">
              Latest Fair-Housing Enforcement ▸
            </span>
            {items.map((it, i) => (
              <a
                key={`${dup}-${i}`}
                href={it.source_url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center group"
              >
                <span className="text-xs font-mono text-white/60 whitespace-nowrap px-5 group-hover:text-white transition-colors">
                  {it.date_label} — {it.title}{it.amount ? ` · ${it.amount}` : ""}
                </span>
                <span className="text-sky-600 text-[10px]">◆</span>
              </a>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
